define.alias("shared/utils/segment/system-labels", "media/utils/segment/system-labels");